export default "__VITE_ASSET__C2x1B9TC__"